import SearchCalendar from "../modules/search-calendar";
import FavouriteExperience from "../modules/favouriteExperience";
import "../modules/favourite";

document.addEventListener("DOMContentLoaded", () => {
  SearchCalendar.setup("search-calendar");
  const instance = new FavouriteExperience();
  if (typeof (window as any).Gloversure === 'undefined') {
      (window as any).Gloversure = {}
  }
  (window as any).Gloversure.FavouriteExperience = instance;
});
